import { NgModule } from '@angular/core';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DatePickerModule, CalendarModule } from '@progress/kendo-angular-dateinputs';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import {
  TabStripModule,
  PanelBarModule,
  SplitterModule,
  TileLayoutModule,
  CardModule,
  AvatarModule,
} from '@progress/kendo-angular-layout';
import { FileSelectModule } from '@progress/kendo-angular-upload';
import { PagerModule } from '@progress/kendo-angular-pager';
import { PopupModule } from '@progress/kendo-angular-popup';
import { ContextMenuModule } from '@progress/kendo-angular-menu';
import { LabelModule } from '@progress/kendo-angular-label';
import { IconModule } from '@progress/kendo-angular-icons';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { EditorModule } from '@progress/kendo-angular-editor';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';

const imports = [
  DropDownsModule,
  InputsModule,
  DatePickerModule,
  CalendarModule,
  GridModule,
  ExcelModule,
  DialogsModule,
  ButtonsModule,
  TabStripModule,
  PanelBarModule,
  SplitterModule,
  FileSelectModule,
  ScrollViewModule,
  PagerModule,
  PopupModule,
  ContextMenuModule,
  IconModule,
  LabelModule,
  LayoutModule,
  EditorModule,
  TileLayoutModule,
  CardModule,
  AvatarModule,
];

@NgModule({
  imports: [...imports],
  exports: [...imports],
})
export class KendoModule {}
